<template>
  <div role="main" class="main-hs321">

    <app-carousel></app-carousel>

    <div class="container">
      <AppWatermanPromo></AppWatermanPromo>
      <AppMewsMain></AppMewsMain>
      <hr>
      <AppCustomers></AppCustomers>
      <hr>
      <h4>
        Закон Галла (от 321): "Сложная система (команда плюс кодовая база), которая работает,
        всегда оказывается эволюционирующей из простой системы, которая работала. Обратное
        предложение также кажется верным: Сложная система, созданная с нуля, никогда не заработает
        и не может быть заставлена работать. Вы должны начать все сначала, начиная с работающей простой системы".
      </h4>
    </div>

  </div>
</template>

<script>
import Carousel from '@/components/parts/Carousel.vue'
import Customers from '@/components/parts/Customers.vue'
import NewsMain from '@/components/parts/NewsMain.vue'
import WatermanPromo from '@/components/pages/WatermanPromo.vue'

export default {
  name: 'Main',
  data () {
    return {
      msg: ''
    }
  },
  components: {
    AppCarousel: Carousel,
    AppCustomers: Customers,
    AppMewsMain: NewsMain,
    AppWatermanPromo: WatermanPromo,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .container {
    margin-top: 60px;
  }
  @media (max-width: 991.98px) {
  .main-hs321 {
    margin-top: 62px;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/parts/Main.vue